import { IconWrapper } from '../runtime';
export default IconWrapper('folder-add-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 25 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.75 20.25C1.50736 20.25 0.5 19.2426 0.5 18L0.5 3C0.5 1.75736 1.50736 0.75 2.75 0.75L7.25 0.75C7.73683 0.75 8.21053 0.9079 8.6 1.2L10.4 2.55C10.7895 2.8421 11.2632 3 11.75 3L22.25 3C23.4926 3 24.5 4.00736 24.5 5.25L24.5 18C24.5 19.2426 23.4926 20.25 22.25 20.25L2.75 20.25Z",
      "fill": "#317FF2"
    }
  }), h("path", {
    "attrs": {
      "d": "M2.75 22.5C1.50736 22.5 0.5 21.4926 0.5 20.25L0.5 7.5C0.5 6.25736 1.50736 5.25 2.75 5.25L22.25 5.25C23.4926 5.25 24.5 6.25736 24.5 7.5L24.5 20.25C24.5 21.4926 23.4926 22.5 22.25 22.5L2.75 22.5Z",
      "fill": 'url(#' + props.id + '91ae31ed' + ')'
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.75 12.75V9.375C11.75 9.16789 11.9179 9 12.125 9H12.875C13.0821 9 13.25 9.16789 13.25 9.375V12.75H16.625C16.8321 12.75 17 12.9179 17 13.125V13.875C17 14.0821 16.8321 14.25 16.625 14.25H13.25V17.625C13.25 17.8321 13.0821 18 12.875 18H12.125C11.9179 18 11.75 17.8321 11.75 17.625V14.25H8.375C8.16789 14.25 8 14.0821 8 13.875V13.125C8 12.9179 8.16789 12.75 8.375 12.75H11.75Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '91ae31ed',
      "x1": "2.75",
      "y1": "6.43828",
      "x2": "19.6823",
      "y2": "24.658",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#30B3FD"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#5589FF"
    }
  })])])]);
});